<template>
    <div >
      <div class='s_flex_bian_c m-b-10' v-for="(value,index) in links " :key="index" >
        <span>{{value.name}}</span>
         <a-button type="primary" @click="choose(value)">
            选择
         </a-button>
      </div>
    </div>
</template>

<script>
import { reactive, toRaw, computed, ref, toRefs } from "vue";
export default {
  name:"pagesLinks",
  setup(pros,{emit}){
    const state= reactive({
      links:[
        {
          name:'个人中心',
          link:"center",
          key:'center'
        }
        ,{
          name:'云店',
          link:"store",
          key:'store'
        }
         
      ]
    })
    const choose=(data)=>{
        emit('select',data)
    }
    return{
      ...toRefs(state),
      choose
    }
  }
}
</script>